import { render, staticRenderFns } from "./TopicClusterLinkAnalysis3.vue?vue&type=template&id=01009fd0&scoped=true"
import script from "./TopicClusterLinkAnalysis3.vue?vue&type=script&lang=js"
export * from "./TopicClusterLinkAnalysis3.vue?vue&type=script&lang=js"
import style0 from "./TopicClusterLinkAnalysis3.vue?vue&type=style&index=0&id=01009fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01009fd0",
  null
  
)

export default component.exports